import { useLang } from '../../_LangContext';
import GTM from '../../_GTM';

export const createTabItems = () => [
    { id: 1, className: "exhibits", iconClass: "tatemono", localeKey: "exhibits" },
    { id: 2, className: "settings", iconClass: "cog", localeKey: "settings" },
    { id: 3, className: "information", iconClass: "information", localeKey: "app-info" },
];

export const handleTabBarClick = (id, lang, navigateSetParam, setActivePageID, tabItems) =>
{
    setActivePageID(id);
    navigateSetParam('page', id.toString(), '1');
    
    const localeKey = tabItems.find(item => item.id === id).localeKey;
    // Note: We can't use useLang hook here since this is not a component
    // The GTM event will be handled by the component that calls this function
};

export const syncPageFromURL = (location, isOpen, activePageID, setActivePageID) =>
{
    if (!isOpen) return;

    const queryParams = new URLSearchParams(window.location.search);
    const pageParam = parseInt(queryParams.get('page'));
    
    if (!isNaN(pageParam) && pageParam !== activePageID) 
    {
        setActivePageID(pageParam);
    }
}; 